<template>
  <div class="boxall">
    <div class="title">仓储物流</div>
    <div class="boxnav">
      <div class="bg-image" @click="handleImageClick">
        <!-- 轮播图片层 -->
        <img
          v-for="(img, i) in images"
          :key="i"
          :src="img"
          class="bg-slide"
          :class="{ active: i === currentIndex }" />

        <!-- 内容层 -->
        <div class="content">
          <div class="item-box">
            <div class="item-icon">
              <img src="../assets/images/collect.png" alt="icon" />
            </div>
            <div class="item-info">
              <div class="item-value">
                <span class="num">2</span>
                <span class="unit">个</span>
              </div>
              <div class="item-label">集站点</div>
            </div>
          </div>

          <div class="item-box">
            <div class="item-icon">
              <img src="../assets/images/sending.png" alt="icon" />
            </div>
            <div class="item-info">
              <div class="item-value">
                <span class="num">{{ yearWeight }}</span>
                <span class="unit">吨</span>
              </div>
              <div class="item-label">累计发货量</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getDashboardData } from '@/api/getData'
import { mapGetters } from 'vuex'

export default {
  name: 'Delivery',

  props: {
    activeComp: {
      type: String,
      default: 'CenterMap'
    }
  },

  data() {
    return {
      currentIndex: 0,
      images: [
        require('../assets/images/delivery/store1.png'),
        require('../assets/images/delivery/store2.png')
      ],
      timer: null

      // number: 0 // 发货量
    }
  },

  // created() {
  //   this.fetchData()
  // },

  mounted() {
    this.startTimer()
    // this.startFetchTimer()
  },

  beforeDestroy() {
    clearInterval(this.timer)
    // clearInterval(this.fetchTimer)
  },

  computed: {
    ...mapGetters('dashboard', ['marketInfo']),

    yearWeight() {
      const { year_weight } = this.marketInfo
      if (!year_weight) return 0
      return +(year_weight / 2000).toFixed(1)
    }
  },

  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.images.length
        // 如果当前是展开状态，同步传出去
        if (this.activeComp === 'DeliveryDetail') {
          this.$emit('syncIndex', this.currentIndex)
        }
      }, 5000)
    },

    // 把当前显示的图片索引传出去
    handleImageClick() {
      this.$emit('switchCenter', this.currentIndex)
      // console.log(this.currentIndex)
    }

    // async fetchData() {
    //   try {
    //     const res = await getDashboardData()
    //     if (res.resultCode == 1) {
    //       const { year_weight } = res.resultInfo.market_info

    //       this.number = +(year_weight / 2000).toFixed(1)
    //     }
    //   } catch (err) {
    //     console.log(err)
    //   }
    // },

    // 每5分钟获取一次数据
    // startFetchTimer() {
    //   this.fetchTimer = setInterval(() => {
    //     this.fetchData()
    //   }, 5 * 60 * 1000)
    // }
  }
}
</script>

<style scoped>
.bg-image {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  cursor: pointer;
}

/* 图片绝对定位叠在底层 */
.bg-slide {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
  opacity: 0;
  transition: opacity 2s ease;
  border-radius: 12px;
}

.bg-slide.active {
  opacity: 1;
}

/* 内容层在图片上面 */
.content {
  position: relative;
  z-index: 1;
  height: 35%;
  background: #303030b0;
  flex: 0 0 35%;
  height: 100%;
  display: flex;
  flex-direction: row;
  padding: 0 16px;
  box-sizing: border-box;
}

.item-box {
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
}

.item-icon {
  height: 40px;
  width: 40px;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  margin-left: 16px;
}

.item-icon img {
  width: 32px;
  height: 32px;
}

.item-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 4px;
}

.item-value {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.num {
  font-size: 28px;
  font-weight: bold;
  color: #00cfff;
  font-family: ds-digitalnormal !important;
}

.unit {
  font-size: 16px;
  color: #7ecfea;
}

.item-label {
  font-size: 14px;
  color: #8fb8c8;
  display: flex;
}
</style>
